import React, { ReactElement, useEffect, useRef, FC } from 'react'
import * as d3 from 'd3'
import * as pc from 'd3-parliament-chart'

interface Props {
  seatColorArray: { seats: number; color: string }[]
}
export const ParliamentChart: FC<Props> = ({
  seatColorArray
}): ReactElement => {
  const graphWidth = 640
  const seatRadius = 10
  let colorOfHoveredSeat: string
  let circlesToHidePerColor: {
    [x: string]: d3.Selection<d3.BaseType, unknown, HTMLElement, any>
  }
  function highlightSeat(colorOfHoveredSeat: string) {
    d3.selectAll('span')
      .filter(function(d) {
        return (
          d3.select(this).attr('class') !== colorOfHoveredSeat.replace('#', '')
        )
      })

      .style('opacity', 0.2)

    circlesToHidePerColor[colorOfHoveredSeat]
      .transition()
      .ease(d3.easeCircleInOut)
      .duration(70)
      .attr('opacity', '.2')
      .attr('r', seatRadius - 2)
  }
  useEffect(() => {
    console.log(seatColorArray)

    const seatRadius = 10
    d3.select('#parliament-chart-svg').call(
      pc
        .parliamentChart()
        .width(graphWidth)
        .aggregatedData(seatColorArray)
        .sections(1)
        .sectionGap(0)
        .seatRadius(10)
        .rowHeight(33)
      // .debug(true)
    )
    seatColorArray.forEach(seatColor => {
      circlesToHidePerColor = {
        ...circlesToHidePerColor,
        [seatColor.color]: d3.selectAll('circle').filter((d, i, nodes) => {
          return d3.select(nodes[i]).attr('fill') !== seatColor.color
        })
      }
    })

    d3.selectAll('circle')
      .attr('stroke-width', 21)
      .attr('stroke', 'hsla(0,0%,100%,.0)')
      .on('mouseover', function(d, i) {
        colorOfHoveredSeat = d3.select(this).attr('fill')
        highlightSeat(colorOfHoveredSeat)
      })
      .on('mouseout', function(d, i) {
        d3.selectAll('circle')
          .transition()
          .ease(d3.easeCircleInOut)
          .duration(70)
          .attr('opacity', '1')
          .attr('r', seatRadius)
        d3.selectAll('span').style('opacity', 1)
      })
    d3.selectAll('span')
      .on('mouseover', function(d, i) {
        colorOfHoveredSeat = '#' + d3.select(this).attr('class')
        highlightSeat(colorOfHoveredSeat)
      })
      .on('mouseout', function(d, i) {
        d3.selectAll('circle')
          .transition()
          .ease(d3.easeCircleInOut)
          .duration(70)
          .attr('opacity', '1')
          .attr('r', seatRadius)
        d3.selectAll('span').style('opacity', 1)
      })
  }, [seatColorArray])

  return (
    <div id='parliament-chart'>
      <svg
        id='parliament-chart-svg'
        viewBox={`0 0 ${graphWidth} ${graphWidth / 2}`}
        width='100%'
      />
    </div>
  )
}
